import {
    Container,
    ContainerGutter,
    ContainerPadding,
    ThemeDefinition
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';

export enum AlertBoxSeverity {
    ERROR,
    WARNING,
    INFO
}

export interface AlertBoxProps {
    readonly severity?: AlertBoxSeverity;
    children?: React.ReactNode;
}

export const getSeverityTextColor = (
    theme: ThemeDefinition,
    severity: AlertBoxSeverity
) => {
    if (severity === AlertBoxSeverity.ERROR) {
        return theme.colors.content.inverted;
    }
    if (severity === AlertBoxSeverity.WARNING) {
        return theme.colors.content.primary;
    }
    if (severity === AlertBoxSeverity.INFO) {
        return theme.colors.content.inverted;
    }
    return theme.colors.content.inverted;
};

export const getSeverityBackgroundColor = (
    theme: ThemeDefinition,
    severity: AlertBoxSeverity
) => {
    if (severity === AlertBoxSeverity.ERROR) {
        return theme.colors.signal.error;
    }
    if (severity === AlertBoxSeverity.WARNING) {
        return theme.colors.signal.offer;
    }
    if (severity === AlertBoxSeverity.INFO) {
        return theme.colors.signal.neutral;
    }
    return theme.colors.signal.neutral;
};

interface StyledAlertBoxProps {
    readonly severity: AlertBoxSeverity;
}

const StyledAlertBox = styled.div<StyledAlertBoxProps>`
    background-color: ${({theme, severity}) =>
        getSeverityBackgroundColor(theme, severity)};
    color: ${({theme, severity}) => getSeverityTextColor(theme, severity)};
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

StyledAlertBox.displayName = 'StyledAlertBox';

export const AlertBox: React.FunctionComponent<AlertBoxProps> = (
    props
): JSX.Element => (
    <StyledAlertBox severity={props.severity || AlertBoxSeverity.ERROR}>
        <Container
            padding={ContainerPadding.dynamic0100}
            wrap="always"
            gutter={ContainerGutter.dynamic0020}
        >
            {props.children}
        </Container>
    </StyledAlertBox>
);
